import { render, staticRenderFns } from "./6_Address.vue?vue&type=template&id=60e5bdc2&scoped=true&"
import script from "./6_Address.vue?vue&type=script&lang=js&"
export * from "./6_Address.vue?vue&type=script&lang=js&"
import style0 from "./6_Address.vue?vue&type=style&index=0&id=60e5bdc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e5bdc2",
  null
  
)

export default component.exports